// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2xggC","signatureButtonsRight":"ModalSign_signatureButtonsRight__28LFA"};